import { createFileRoute } from '@tanstack/react-router';

import { PayrollPage } from '@/features/workforce/payroll-page';

export const Route = createFileRoute('/_app/projects/$projectId/workforce/payroll/')({
  component: PayrollRoute,
});

function PayrollRoute() {
  const { projectId } = Route.useParams();
  return <PayrollPage projectId={projectId} />;
}
